import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	divider: {
		backgroundColor: "transparent"
	}
})

export default useStyles
